// extracted by mini-css-extract-plugin
module.exports =  {"Limitation":"Limitation__R8fto","highlight":"highlight__uYvrR","applyLowGpm":"applyLowGpm__-LKO1","costTooltip":"costTooltip__phyqq"};